import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { InputSwitch } from "primereact/inputswitch";
import { MAX_LARGO_DESCRIPCION } from '../../../utilities/textValidations.js';

const FormEditarSubproducto = ({
    showEditDialog,
    setShowEditDialog,
    setSubproducto,
    descripcion,
    setDescripcion,
    handleSaveSubproducto,
    incluido,
    setIncluido,
}) => {
    const limpiarFormulario = () => {
        setSubproducto({
            descripcion: ""
        });
        setShowEditDialog(false);
    };

    const handleSaveClick = async () => {
        try {
            await handleSaveSubproducto();
        } catch (error) {
            console.error("Error al guardar:", error);
            alert("Error al actualizar el subproducto: " + error.message);
        }
    };

    const footerEditarProd = () => {
        return (
            <div className="p-d-flex p-jc-end p-mt-3">
                <Button
                    label="Cancelar"
                    icon="pi pi-times"
                    onClick={limpiarFormulario}
                    className="p-button p-mr-2 p-button-outlined p-button-rounded"
                />
                <Button
                    label="Guardar"
                    icon="pi pi-save"
                    onClick={handleSaveClick}
                    className="p-button-success p-button-rounded p-button"
                    raised
                    autoFocus
                />
            </div>
        );
    };

    return (
        <div className="form-container">
            <Dialog
                visible={showEditDialog}
                className="p-fluid product-dialog"
                onHide={limpiarFormulario}
                footer={footerEditarProd()}
                header="Editar Tipo Subproducto"
            >
                <div className="card">
                    <h6 className="mb-3">
                        Información del Subproducto
                    </h6>

                    <span className="p-float-label mt-2 mb-3">
                        <InputText
                            id="descripcion"
                            value={descripcion}
                            onChange={(e) =>setDescripcion(e.target.value.toUpperCase())}
                            className="p-inputtext-lg"
                            placeholder="Ingrese la descripción del producto"
                            maxLength={MAX_LARGO_DESCRIPCION}
                        />
                        <label htmlFor="descripcion"><i className="pi pi-file-edit mr-2"></i>Descripción</label>
                    </span>

                    <div className="flex align-items-center gap-2 mt-3 mb-3">
                        <InputSwitch
                            inputId="editIncluido"
                            checked={incluido === true}
                            onChange={(e) => setIncluido(e.value)}
                        />
                        <label htmlFor="editIncluido" className="mb-0">
                            <i className="pi pi-check-square mr-1"></i>Incluido por defecto en cotizaciones
                        </label>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default FormEditarSubproducto;
